import Vimeo from '@vimeo/player';
import computedStyle from 'computed-style';

export default class BackgroundVideo {
  static init(...parameters) {
    return new BackgroundVideo(...parameters);
  }

  constructor(block) {
    this.block = block;
    this.background = document.querySelector(`#${block.id} > .background`);

    if (this.background) {
      this.video = document.querySelector(`#${block.id} > .background > .video`);
      if (!this.video) {
        return;
      }

      this.poster = document.querySelector(`#${block.id} > .background > .image`);

      this.playButton = document.querySelector(`#${block.id} > .play-button`);
      this.playButtonLabel = document.querySelector(`#${block.id} > .play-button > .label`);
      this.playLabel = this.playButtonLabel.dataset.labelPlay;
      this.pauseLabel = this.playButtonLabel.dataset.labelPause;

      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.paused = true;
      if (this.video && computedStyle(this.video, 'visibility') === 'visible') {
        this.initVimeo();
      }
    }
  }

  initVimeo() {
    this.iframe = this.video.querySelector('iframe');
    this.resizeIframe();
    window.addEventListener('resize', (event) => this.resizeIframe(event));

    const player = this.video.querySelector('.player');
    if (player) {
      const vimeo = new Vimeo(player);
      vimeo.ready().then(() => {
        if (!this.reduceMotion) {
          vimeo.play();
        }
      });

      vimeo.on('play', () => {
        this.onPlay();
      });

      vimeo.on('pause', () => {
        this.onPause();
      });

      vimeo.setVolume(0);

      this.vimeo = vimeo;

      this.playButton.addEventListener('click', () => {
        vimeo.getPaused().then((paused) => {
          if (paused) {
            vimeo.play();
          } else {
            vimeo.pause();
          }
        }).catch((error) => {
          console.error('Error getting paused state:', error);
        });
      });
    }
  }

  onReady() {
    this.resizeIframe();
    window.addEventListener('resize', (event) => this.resizeIframe(event));
  }

  onPlay() {
    this.playButton.classList.add('-playing');
    this.playButtonLabel.innerText = this.pauseLabel;
    if (this.poster) {
      this.poster.classList.add('-playing');
    }
  }

  onPause() {
    this.playButton.classList.remove('-playing');
    this.playButtonLabel.innerText = this.playLabel;
  }

  resizeIframe() {
    let width = this.block.offsetWidth;
    let height = this.block.offsetHeight;

    if ((width / height) > (16 / 9)) {
      height = Math.ceil((width / 16) * 9) + 2; // Fix rounding error
      width = Math.ceil(width) + 2; // Fix rounding error

      this.iframe.style.width = `${width}px`;
      this.iframe.style.height = `${height}px`;
    } else {
      width = Math.ceil((height / 9) * 16) + 2; // Fix rounding error
      height = Math.ceil(height) + 2; // Fix rounding error

      this.iframe.style.width = `${width}px`;
      this.iframe.style.height = `${height}px`;
    }
  }
}
